import React, {Component} from "react"
import {debounce} from "lodash"
import PropTypes from "prop-types"

import {connect} from "@irati/store/connect"
import authentication from "@irati/auth"
import {injectIntl} from "@irati/utils/lang"
import History from "@irati/utils/history"
import id from "@irati/utils/id"
import Loading from "@irati/ui/src/Loading"
import Hr from "@irati/ui/src/Layout/Hr"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import IconButton from "@irati/ui/src/Button/IconButton"
import Input from "@irati/ui/src/FormItem/Input"
import Flex from "@irati/ui/src/Flex"
import tracking from "@irati-tracking/perks/perks"

import SearchModal from "./styled/SearchModal"
import {isSearchTermValid} from "../../../helpers/search/validation"
import {newSearch, pendLoadResults, retryLastSearch, clearResults} from "../../../store/actions/SearchActions"
import {DEFAULT_DEBOUNCE_SEARCH_DELAY} from "../../../constants/search"

import ErrorState from "./ErrorState"
import ResultsState from "./ResultsState"

class SearchBar extends Component {
  static propTypes = {
    show: PropTypes.bool,
    onClose: PropTypes.func,
    fetchNewSearch: PropTypes.func.isRequired,
    pendFetchNewSearch: PropTypes.func.isRequired,
    search: PropTypes.object.isRequired,
    clearSearch: PropTypes.func.isRequired,
    retryLastSearch: PropTypes.func.isRequired,
    formatMessage: PropTypes.func.isRequired
  }

  static defaultProps = {
    show: false,
    onClose: () => {}
  }

  static contextTypes = {
    appPath: PropTypes.string.isRequired,
    apps: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      value: "",
      results: [],
      hasError: false,
      count: 0,
      total: 0,
      isLoading: false,
      isEmpty: false,
      searchTerm: ""
    }

    this.debounceFetchSearch = debounce(props.fetchNewSearch, DEFAULT_DEBOUNCE_SEARCH_DELAY)
  }

  componentDidCatch(error, info) {
    console.log(error, info)
  }

  handleInput = (searchTerm) => {
    /** set state changes */
    this.setSearchTermAndValidity(searchTerm)

    /** Set user is typing / pend fetch */
    this.props.pendFetchNewSearch()

    /** Update the  */
    if (searchTerm) {
      this.debounceFetchSearch(searchTerm)
    }
  }

  setSearchTermAndValidity(searchTerm) {
    this.setState({
      searchTerm,
      isValidSearchTerm: isSearchTermValid(searchTerm)
    })
  }

  onKeyDown = (e) => {
    const searchTerm = e.target.value
    if (e.keyCode === 13 && isSearchTermValid(searchTerm)) {
      History.push(`/search/perks?q=${encodeURIComponent(searchTerm)}`, this.context.apps.PLATFORM)
    }
  }

  onItemSelect = (deal) => {
    tracking.clickSearchResult(deal)
    this.onHide(true)
  }

  onHide = (itemSelected) => {
    const {results} = this.props.search
    const {searchTerm} = this.state
    if (typeof itemSelected !== "boolean" || !itemSelected) {
      tracking.abandonSearch(results.total, searchTerm)
    }
    this.props.onClose()
    this.setSearchTermAndValidity("")
    this.props.clearSearch()
  }

  render() {
    const {isValidSearchTerm, searchTerm} = this.state
    const {show} = this.props
    const {load, results} = this.props.search
    const idNamespace = id("search-bar", this.props)
    const isGeoLocationEnabled = authentication.apps("platform.geoLocation")

    return (
      <SearchModal
        id={idNamespace}
        show={show}
        className="search-popup searchModal"
        onHide={this.onHide}
        width={isGeoLocationEnabled ? "60%" : "40%"}>
        <div
          id={id("wrapper", idNamespace)}
          className="searchModal_wrapper">
          <Flex alignItems="center" justifyContent="space-between">
            <Flex alignItems="center">
              <Icon id={id("icon", idNamespace)} icon={IconTypes.search} size={24} />
              <Input
                id={id("input", idNamespace)}
                inputRef={(input) => {if (input) input.focus()}}
                onChange={(value) => this.handleInput(value)}
                onKeyDown={this.onKeyDown}
                value={searchTerm}
                name="search"
                flush
                hideBorder
                placeholder={this.props.formatMessage({id: "perks.components.searchPopup.placeholder"})} />
            </Flex>
            <IconButton id={id("btn-close", idNamespace)} icon={IconTypes.close} onClick={this.onHide} />
          </Flex>

          {isValidSearchTerm && (
            <div style={{marginTop: "16px"}}>
              <Hr large solid className="flush--top" />
              <Loading load={load} Error={() => <ErrorState id={idNamespace} retry={this.props.retryLastSearch} />}>
                <ResultsState
                  id={idNamespace}
                  searchTerm={searchTerm}
                  results={results}
                  onItemSelect={this.onItemSelect}
                  onViewAllClick={this.onHide} />
              </Loading>
            </div>
          )}
        </div>
      </SearchModal>
    )
  }
}

/**
 * Add Redux state & export
 */
export const mapStateToProps = ({search}) => ({search})

export const mapDispatchToProps = (dispatch) => {
  return {
    fetchNewSearch: (term) => {
      return dispatch(newSearch(term))
    },
    pendFetchNewSearch: () => {
      return dispatch(pendLoadResults())
    },
    retryLastSearch: () => {
      return dispatch(retryLastSearch())
    },
    clearSearch: () => {
      return dispatch(clearResults())
    }
  }
}
export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SearchBar)
)
